import { EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { CommonConstant, InfluencerTabName } from '../../../app.constants';
import { UserService } from '../../../services/user.service';
import { ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from '../../../services/cache/cache.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { ObjectUtils } from '../../../utils/object.utils';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { AppSettings } from '../../../utils/app-settings';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { BlockedReason, InvalidAction, WallType } from '../../../../models/user';
import { WebUtils } from '../../../utils/web.utils';
import { map } from 'rxjs/operators';
var InfluencerInsightComponent = /** @class */ (function () {
    function InfluencerInsightComponent(influencerService, pdfExportService, referenceDataService, eventTracker, userService, cacheService, translate, modalService, activatedRoute) {
        this.influencerService = influencerService;
        this.pdfExportService = pdfExportService;
        this.referenceDataService = referenceDataService;
        this.eventTracker = eventTracker;
        this.userService = userService;
        this.cacheService = cacheService;
        this.translate = translate;
        this.modalService = modalService;
        this.activatedRoute = activatedRoute;
        this.TOTAL_MODULE = 7; // [IMPORTANT] Todo: update number of modules for visting influencer logic
        this.changeActiveChannel = new EventEmitter();
        // list all supported platforms
        this.platformList = [];
        this.topExposures = [];
        this.isFetchingTopExposures = true;
        this.bestPerformingExposures = [];
        this.isFetchingbestPerformingExposures = true;
        this.isFetchingPerformanceTimeline = true;
        this.isFetchingKpi = true;
        // active channel
        this.influencerChannelList = [];
        // module loaded counter
        this.loadModuleCounterSubject = new BehaviorSubject(0);
        // show/hide fallback if limit has been reached
        this.fallbackMsgTitle = this.translate.instant('INFLUENCER.insight.fallback_title');
        // follower growth
        this.followerGrowths = [];
        this.isFetchingFollowerGrowths = true;
        this.isFetchingChannelFollowers = true;
        this.isFetchingChannelInteractionRateDevelopments = true;
    }
    InfluencerInsightComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.influencerService.isCreditAvailable() === true) {
            this.sendViewActionToSegement();
        }
        else if (this.influencerService.isCreditAvailable() === false) {
            this.sendInvalidViewToSegement();
        }
        this.platformList = this.referenceDataService.platforms;
        if (this.userService.isInfluencer) {
            this.initializeInsightPage(this.influencerId);
        }
        else {
            this.creditAvailabilitySubscription = this.influencerService.creditAvailabilityObserve.subscribe(function (res) {
                if (res === true) {
                    _this.showFallback = false;
                    _this.initializeInsightPage(_this.influencerId);
                }
                if (res === false) {
                    _this.fallbackMsgContent = _this.translate.instant('INFLUENCER.insight.fallback_msg', {
                        maxCredit: _this.userService.maxActiveInfluencers
                    });
                    _this.showFallback = true;
                }
            });
        }
    };
    InfluencerInsightComponent.prototype.ngOnDestroy = function () {
        if (this.channelSubscription) {
            this.channelSubscription.unsubscribe();
        }
        if (this.loadModuleCounterSubscription) {
            this.loadModuleCounterSubscription.unsubscribe();
        }
        if (this.creditAvailabilitySubscription) {
            this.creditAvailabilitySubscription.unsubscribe();
        }
        this.influencerActivityLineChartData = null;
        this.modalService.close();
    };
    InfluencerInsightComponent.prototype.initializeInsightPage = function (influencerId) {
        var _this = this;
        this.loadListChannel(influencerId, this.influencerService.currentActiveChannel)
            .subscribe(function (activeChannel) {
            _this.activeChannel = activeChannel;
            _this.selectedChannelId = activeChannel.id;
            // load insight data
            _this.processInfluencerDetailByChannel(influencerId, _this.activeChannel);
            // observe the loaded module. Whenever all modules are loaded, check if at least one module has available data, if so, track view
            _this.loadModuleCounterSubscription = _this.loadModuleCounterSubject.asObservable().subscribe(function (value) {
                if (value === _this.TOTAL_MODULE) {
                    if (_this.hasInsightData()) {
                        // call API mark as visited
                        _this.markInfluencerAsVisited(influencerId, _this.userService.getCompanyId());
                    }
                }
            });
            // watching active channel change
            _this.channelSubscription = _this.influencerService.activeChannel.subscribe(function (channel) {
                if (channel && _this.isSupportedChannel(channel.id) && (!_this.activeChannel || (channel.id !== _this.activeChannel.id))) {
                    _this.activeChannel = channel && channel.id > 0 ? channel : null;
                    _this.selectedChannelId = channel && channel.id > 0 ? channel.id : null;
                    _this.processInfluencerDetailByChannel(influencerId, _this.activeChannel);
                }
            });
        });
    };
    InfluencerInsightComponent.prototype.onChangeChannel = function (channel) {
        var _this = this;
        if (Array.isArray(channel)) {
            return;
        }
        setTimeout(function () {
            _this.influencerService.updateActiveChannel(channel);
            _this.changeActiveChannel.emit({
                activeTab: InfluencerTabName.INSIGHT,
                channel: channel.id > 0 ? channel.id : null
            });
        }, 200);
    };
    InfluencerInsightComponent.prototype.sendInvalidViewToSegement = function () {
        var detailAction = new InvalidAction(true, BlockedReason.ACCOUNT_WALL, WallType.USAGE_LIMIT, 'Insights Limit', false, null, null, this.userService.accountLevelName);
        this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.VIEW, Page.INFLUENCER_INSIGHTS);
    };
    InfluencerInsightComponent.prototype.sendViewActionToSegement = function () {
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.INFLUENCER_INSIGHTS, {
            id: this.influencerService.influencerDetails.id,
            name: this.influencerService.influencerDetails.name,
            type: TargetType.INFLUENCER
        }, undefined, undefined, {
            type: ActivePages.INFLUENCER_INSIGHTS,
            name: this.influencerService.influencerDetails.name,
            id: this.influencerService.influencerDetails.id
        });
    };
    InfluencerInsightComponent.prototype.increaseNumberLoadedModule = function () {
        var currentValue = this.loadModuleCounterSubject.getValue();
        this.loadModuleCounterSubject.next(currentValue + 1);
    };
    InfluencerInsightComponent.prototype.hasInsightData = function () {
        if (this.enableInfluencerPlatform) {
            return true;
        }
        // Todo: add check data for feature modules
        return (this.influencerActivityLineChartData && this.influencerActivityLineChartData.length > 0)
            || (this.influencerChannelKPIData && this.influencerChannelKPIData.engagement && this.influencerChannelKPIData.impact && this.influencerChannelKPIData.impressions)
            || (this.topExposures && this.topExposures.length > 0)
            || (this.bestPerformingExposures && this.bestPerformingExposures.length > 0)
            || (this.channelInteractionRates && this.channelInteractionRates.length > 0)
            || (this.followerGrowths && this.followerGrowths.length > 0)
            || (this.channelFollowers && this.channelFollowers.length > 0)
            || (this.channelReaches && this.channelReaches.length > 0)
            || (this.channelInteractionRateDevelopments && this.channelInteractionRateDevelopments.length > 0);
    };
    InfluencerInsightComponent.prototype.canViewInsightData = function () {
        if (this.userService.isInfluencer) {
            return true;
        }
        return this.influencerService.isCreditAvailable() === true;
    };
    InfluencerInsightComponent.prototype.showFallbackView = function () {
        if (this.userService.isInfluencer) {
            return false;
        }
        return this.influencerService.isCreditAvailable() === false;
    };
    InfluencerInsightComponent.prototype.markInfluencerAsVisited = function (influencerId, companyId) {
        var _this = this;
        this.influencerService.visitInfluencer(influencerId, companyId).subscribe({
            next: function (res) {
                if (res === null) {
                    return;
                }
                _this.userService.triggerUpdateActivatedInfluencers();
            }
        });
    };
    /*
    Load supported channel list and determine selected channel
    */
    InfluencerInsightComponent.prototype.loadListChannel = function (influencerId, initialChannel) {
        var _this = this;
        return this.influencerService.fetchListChannel(influencerId).pipe(map(function (res) {
            var supportedChannels = res.filter(function (c) { return AppSettings.getActivePlatformList().indexOf(c.platformName.toLowerCase()) >= 0; });
            _this.influencerChannelList = supportedChannels;
            var hasSelectedChannel = initialChannel && initialChannel.id;
            if (hasSelectedChannel) {
                return initialChannel;
            }
            // pre-select the first channel if initialChannel is not available
            var seletedChannel = supportedChannels[0];
            _this.influencerService.updateActiveChannel(seletedChannel);
            _this.changeActiveChannel.emit({
                activeTab: InfluencerTabName.INSIGHT,
                channel: seletedChannel.id
            });
            return seletedChannel;
        }));
    };
    InfluencerInsightComponent.prototype.isSupportedChannel = function (channelId) {
        if (!this.influencerChannelList) {
            return false;
        }
        return this.influencerChannelList.findIndex(function (ic) { return ic.id === channelId; }) >= 0;
    };
    InfluencerInsightComponent.prototype.processInfluencerDetailByChannel = function (influencerId, activeChannel) {
        // calculate KPI and platform reachs of influencer
        this.calculateInfluencerKpiAndPlatformReach(influencerId, activeChannel);
        // load daily kpis data
        this.getDailyKpisByChannel(influencerId, activeChannel);
        // load top exposure posts
        this.getTopExposurePostsByChannel(influencerId, activeChannel);
        // load best performing posts
        this.getBestPerformingPostsByChannel(influencerId, activeChannel);
        // load follower growth
        this.getFollowerGrowth(activeChannel);
        // load channel followers
        this.getInfluencerFollowers(influencerId, this.influencerChannelList);
        // load channel interaction rate development
        this.getChannelInteractionRateDevelopment(activeChannel);
    };
    /**
     * get details of influencer
     * @param influencerId
     * @param activeChannel
     */
    InfluencerInsightComponent.prototype.calculateInfluencerKpiAndPlatformReach = function (influencerId, activeChannel) {
        var _this = this;
        this.isFetchingKpi = true;
        this.cacheService.get("influencer_" + influencerId, this.influencerService.getInfluencer(influencerId))
            .subscribe(function (data) {
            _this.increaseNumberLoadedModule();
            _this.isFetchingKpi = false;
            if (!data) {
                return;
            }
            _this.influencerChannelKPIData = _this.influencerService.normalizeChannelAverageKpi(data.channelAverageKpis, data.average, activeChannel);
            _this.globalChannelKpi = _this.getGlobalKpiByChannel(data.channelGlobalKpis, data.globalKpi, activeChannel);
            _this.channelInteractionRates = _this.getChannelInteractionRates(data.channelAverageKpis, _this.influencerChannelList);
            _this.channelReaches = _this.getChannelReaches(data.rawChannelGlobalKpis, _this.influencerChannelList);
        });
    };
    InfluencerInsightComponent.prototype.getChannelInteractionRates = function (channelAverageKpis, supportedChannels) {
        var results = [];
        if (!Array.isArray(channelAverageKpis) || channelAverageKpis.length === 0) {
            return results;
        }
        var mappedChannelsCount = 0;
        supportedChannels.forEach(function (channel) {
            var mappedKPI = channelAverageKpis.find(function (kpi) { return Number(kpi.channel_id) === channel.id; });
            var interactionRate = 0;
            if (mappedKPI) {
                interactionRate = (mappedKPI.engagement_rate_avg === undefined || mappedKPI.engagement_rate_avg === null)
                    ? 0
                    : mappedKPI.engagement_rate_avg * 100;
                mappedChannelsCount++;
            }
            results.push({
                channelId: channel.id,
                channelName: channel.name,
                platformId: channel.platformId,
                platformName: channel.platformName,
                interactionRate: interactionRate
            });
        });
        // No data for all channels
        if (mappedChannelsCount === 0) {
            return [];
        }
        return results;
    };
    InfluencerInsightComponent.prototype.getChannelReaches = function (rawChannelGlobalKpis, supportedChannels) {
        var results = [];
        if (!Array.isArray(rawChannelGlobalKpis) || rawChannelGlobalKpis.length === 0) {
            return results;
        }
        var reachSum = 0;
        var mappedChannelsCount = 0;
        supportedChannels.forEach(function (channel) {
            var mappedKPI = rawChannelGlobalKpis.find(function (kpi) { return Number(kpi.channel_id) === channel.id; });
            if (mappedKPI) {
                results.push({
                    channelId: channel.id,
                    channelName: channel.name,
                    platformName: channel.platformName,
                    reach: mappedKPI.reach,
                    reachChangePercentage: mappedKPI.reach_change * 100
                });
                reachSum += mappedKPI.reach;
                mappedChannelsCount++;
            }
            else {
                results.push({
                    channelId: channel.id,
                    channelName: channel.name,
                    platformName: channel.platformName,
                    reach: 0,
                    reachChangePercentage: 0
                });
            }
        });
        // No data for all channels
        if (mappedChannelsCount === 0) {
            return [];
        }
        results.forEach(function (r) { return r.reachPercentage = r.reach / reachSum * 100; });
        return results;
    };
    InfluencerInsightComponent.prototype.onChannelReachMaxChannelSelectionExceeded = function () {
        this.modalService.close();
        this.modalService.open(this._channelReachNotificationPopup, null, true);
    };
    /**
     * fetch top exposure posts of influencer by channel
     * @param influencerId
     * @param activeChannel
     */
    InfluencerInsightComponent.prototype.getTopExposurePostsByChannel = function (influencerId, activeChannel) {
        var _this = this;
        this.isFetchingTopExposures = true;
        this.topExposures = [];
        var topExposureParams = {
            period: CommonConstant.PERIOD_30_DAYS
        };
        var cachingKey = "influencer_top_exposures_" + influencerId;
        if (activeChannel) {
            topExposureParams = Object.assign({}, topExposureParams, {
                channelId: activeChannel.id
            });
            cachingKey = "channel_top_exposures_" + activeChannel.id;
        }
        this.cacheService.get(cachingKey, this.influencerService.getTopExposures(influencerId, topExposureParams))
            .subscribe(function (res) {
            _this.increaseNumberLoadedModule();
            _this.isFetchingTopExposures = false;
            if (!res) {
                return;
            }
            _this.topExposures = _this.formatTopExposureData(res);
        }, function (err) {
            _this.topExposures = [];
            _this.increaseNumberLoadedModule();
            _this.isFetchingTopExposures = false;
        });
    };
    InfluencerInsightComponent.prototype.formatTopExposureData = function (data) {
        if (data.reach.influencer_id || data.engagement.influencer_id || data.impact.influencer_id) {
            return [data.reach, data.engagement, data.impact];
        }
        return [];
    };
    /**
     * fetch daily kpi data of influencer by channel
     * @param influencerId
     * @param activeChannel
     */
    InfluencerInsightComponent.prototype.getDailyKpisByChannel = function (influencerId, activeChannel) {
        var _this = this;
        this.isFetchingPerformanceTimeline = true;
        var performanceTimelineParams = {
            period: CommonConstant.PERIOD_30_DAYS
        };
        var cachingKey = "influencer_daily_kpis_" + influencerId;
        if (this.enableInfluencerPlatform) {
            performanceTimelineParams = Object.assign({}, performanceTimelineParams, {
                period: CommonConstant.PERIOD_7_DAYS
            });
        }
        if (activeChannel) {
            performanceTimelineParams = Object.assign({}, performanceTimelineParams, {
                channelId: activeChannel.id
            });
            cachingKey = "channel_daily_kpis_" + activeChannel.id;
        }
        this.cacheService.get(cachingKey, this.influencerService.getDailyKpiTimeLineChart(influencerId, performanceTimelineParams))
            .subscribe(function (res) {
            _this.isFetchingPerformanceTimeline = false;
            _this.influencerActivityLineChartData = ObjectUtils.deepClone(res);
            _this.increaseNumberLoadedModule();
        });
    };
    /**
     * fetch best performing posts in 30 days of influencer based on channel
     * @param influencerId
     * @param activeChannel
     */
    InfluencerInsightComponent.prototype.getBestPerformingPostsByChannel = function (influencerId, activeChannel) {
        var _this = this;
        this.isFetchingbestPerformingExposures = true;
        this.bestPerformingExposures = [];
        var bestPerformingParams = {
            period: CommonConstant.PERIOD_30_DAYS,
            limit: CommonConstant.LIMIT_20
        };
        var cachingKey = "influencer_best_performing_" + influencerId;
        if (activeChannel) {
            bestPerformingParams = Object.assign({}, bestPerformingParams, {
                channelId: activeChannel.id
            });
            cachingKey = "channel_best_performing_" + activeChannel.id;
        }
        this.cacheService.get(cachingKey, this.influencerService.getBestPerforming(influencerId, bestPerformingParams))
            .subscribe({
            next: function (res) {
                _this.bestPerformingExposures = res;
                _this.increaseNumberLoadedModule();
                _this.isFetchingbestPerformingExposures = false;
            },
            error: function (error) {
                _this.increaseNumberLoadedModule();
                _this.isFetchingbestPerformingExposures = false;
                WebUtils.reportErrorToSentry('Load influencer best performing posts fails', error);
                _this.showError(_this.translate.instant('INFLUENCER.insight.best_performing_posts.load_error_message'));
            }
        });
    };
    InfluencerInsightComponent.prototype.getGlobalKpiByChannel = function (channelGlobalKpis, globalKpi, activeChannel) {
        if (!Array.isArray(channelGlobalKpis) || channelGlobalKpis.length === 0) {
            return null;
        }
        if (activeChannel) {
            return channelGlobalKpis.find(function (gk) { return gk.channelId === activeChannel.id; });
        }
        return globalKpi;
    };
    InfluencerInsightComponent.prototype.getInfluencerFollowers = function (influencerId, supportedChannels) {
        var _this = this;
        this.isFetchingChannelFollowers = true;
        this.channelFollowers = [];
        var cachingKey = "influencer_followers_" + influencerId;
        this.cacheService.get(cachingKey, this.influencerService.getInfluencerFollowers(influencerId))
            .subscribe({
            next: function (data) {
                _this.increaseNumberLoadedModule();
                _this.isFetchingChannelFollowers = false;
                if (data) {
                    var channelFollowers_1 = [];
                    var channels_1 = data.channels;
                    if (channels_1.length === 0) {
                        _this.channelFollowers = [];
                        return;
                    }
                    var mappedChannelsCount_1 = 0;
                    supportedChannels.forEach(function (channel) {
                        var mappedChannelFollower = channels_1.find(function (x) { return x.channelId === channel.id; });
                        var followerCount = 0;
                        if (mappedChannelFollower) {
                            followerCount = mappedChannelFollower.followerCount;
                            mappedChannelsCount_1++;
                        }
                        channelFollowers_1.push({
                            channelId: channel.id,
                            channelName: channel.name,
                            platformName: channel.platformName,
                            followerCount: followerCount
                        });
                    });
                    // No data for all channels
                    if (mappedChannelsCount_1 === 0) {
                        _this.channelFollowers = [];
                        return;
                    }
                    _this.channelFollowers = channelFollowers_1;
                }
            },
            error: function (error) {
                _this.increaseNumberLoadedModule();
                _this.isFetchingChannelFollowers = false;
                WebUtils.reportErrorToSentry('Load channel followers fails', error);
                _this.showError(_this.translate.instant('INFLUENCER.insight.follower_by_channel.load_error_message'));
            }
        });
    };
    InfluencerInsightComponent.prototype.getFollowerGrowth = function (activeChannel) {
        var _this = this;
        this.followerGrowths = [];
        this.isFetchingFollowerGrowths = true;
        var channelId = activeChannel && activeChannel.id;
        this.influencerService.getFollowerGrowth(channelId)
            .subscribe({
            next: function (followerGrowths) {
                _this.followerGrowths = followerGrowths;
                _this.increaseNumberLoadedModule();
                _this.isFetchingFollowerGrowths = false;
            },
            error: function (error) {
                _this.increaseNumberLoadedModule();
                _this.isFetchingFollowerGrowths = false;
                WebUtils.reportErrorToSentry('Load influencer follower growth fails', error);
                _this.showError(_this.translate.instant('INFLUENCER.insight.follower_growth.load_error_message'));
            }
        });
    };
    InfluencerInsightComponent.prototype.getChannelInteractionRateDevelopment = function (activeChannel) {
        var _this = this;
        this.channelInteractionRateDevelopments = [];
        this.isFetchingChannelInteractionRateDevelopments = true;
        var channelId = activeChannel && activeChannel.id;
        var cachingKey = "channel_interaction_rate_development_" + channelId;
        this.cacheService.get(cachingKey, this.influencerService.getChannelInteractionRateDevelopment(channelId))
            .subscribe({
            next: function (channelInteractionRateDevelopments) {
                _this.channelInteractionRateDevelopments = channelInteractionRateDevelopments;
                _this.increaseNumberLoadedModule();
                _this.isFetchingChannelInteractionRateDevelopments = false;
            },
            error: function (error) {
                _this.increaseNumberLoadedModule();
                _this.isFetchingChannelInteractionRateDevelopments = false;
                WebUtils.reportErrorToSentry('Load channel interaction rate development fails', error);
                _this.showError(_this.translate.instant('INFLUENCER.insight.interaction_rate_development.load_error_message'));
            }
        });
    };
    InfluencerInsightComponent.prototype.showError = function (message) {
        this.modalService.close();
        this.errorMessage = message;
        this.modalService.open(this._errorPopup, null, true);
    };
    Object.defineProperty(InfluencerInsightComponent.prototype, "lineChartTitle", {
        get: function () {
            return this.enableInfluencerPlatform ? this.translate.instant('INFLUENCER.insight.activity_chart.ip_title')
                : this.translate.instant('INFLUENCER.insight.activity_chart.title');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerInsightComponent.prototype, "isExportingPdf", {
        get: function () {
            return this.pdfExportService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerInsightComponent.MAX_SELECTED_ITEM = 4;
    return InfluencerInsightComponent;
}());
export { InfluencerInsightComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-insight.component.ts.pre-build-optimizer.js